document.addEventListener('DOMContentLoaded', function () {

  // ── WISHLIST UTILS ─────────────────────────────────
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('cranio_wishlist') || '[]'); }
    catch { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem('cranio_wishlist', JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().some(p => p.handle === handle);
  }

  function toggleWishlist(handle, title, image, url) {
    let list = getWishlist();
    const idx = list.findIndex(p => p.handle === handle);
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push({ handle, title, image, url });
    }
    saveWishlist(list);
    updateAllButtons();
    updateHeaderBubble();
  }

  // ── PULSANTE WISHLIST NELLA SCHEDA PRODOTTO ────────
  function initProductPageButton() {
    const btn = document.querySelector('.cranio-wishlist-btn[data-handle]');
    if (!btn) return;

    const handle = btn.dataset.handle;
    updateBtn(btn, isInWishlist(handle));

    btn.addEventListener('click', function () {
      const title = btn.dataset.title;
      const image = btn.dataset.image;
      const url   = btn.dataset.url;
      toggleWishlist(handle, title, image, url);
      updateBtn(btn, isInWishlist(handle));
    });
  }

  function updateBtn(btn, active) {
    if (active) {
      btn.classList.add('--active');
      btn.setAttribute('aria-label', 'Rimuovi dalla wishlist');
    } else {
      btn.classList.remove('--active');
      btn.setAttribute('aria-label', 'Aggiungi alla wishlist');
    }
  }

  function updateAllButtons() {
    document.querySelectorAll('.cranio-wishlist-btn[data-handle]').forEach(btn => {
      updateBtn(btn, isInWishlist(btn.dataset.handle));
    });
  }

  // ── BUBBLE WISHLIST NELL'HEADER ────────────────────
  function updateHeaderBubble() {
    const count = getWishlist().length;
    let bubble = document.querySelector('.cranio-wishlist-bubble');
    const icon  = document.querySelector('.cranio-wishlist-header-icon');
    if (!icon) return;

    if (!bubble) {
      bubble = document.createElement('span');
      bubble.className = 'cranio-wishlist-bubble';
      icon.appendChild(bubble);
    }
    bubble.textContent = count;
    bubble.style.display = count > 0 ? 'flex' : 'none';
  }

  // ── PAGINA WISHLIST ────────────────────────────────
  function renderWishlistPage() {
    const container = document.querySelector('#cranio-wishlist-page');
    if (!container) return;

    const list = getWishlist();
    if (list.length === 0) {
      container.innerHTML = '<p style="text-align:center;padding:40px;font-size:1.6rem;">La tua wishlist è vuota.</p>';
      return;
    }

    container.innerHTML = list.map(p => `
      <div class="cranio-wishlist-item" data-handle="${p.handle}" style="display:flex;align-items:center;gap:16px;padding:16px 0;border-bottom:1px solid #eee;">
        <a href="${p.url}">
          <img src="${p.image}" alt="${p.title}" style="width:80px;height:80px;object-fit:contain;border-radius:8px;">
        </a>
        <div style="flex:1;">
          <a href="${p.url}" style="font-size:1.6rem;font-weight:700;color:#3d1a6b;text-decoration:none;">${p.title}</a>
        </div>
        <button class="cranio-wishlist-remove" data-handle="${p.handle}" style="background:none;border:none;cursor:pointer;color:#7b2fbe;font-size:1.4rem;text-decoration:underline;">
          Rimuovi
        </button>
      </div>
    `).join('');

    container.querySelectorAll('.cranio-wishlist-remove').forEach(btn => {
      btn.addEventListener('click', function () {
        const list = getWishlist().filter(p => p.handle !== btn.dataset.handle);
        saveWishlist(list);
        renderWishlistPage();
        updateHeaderBubble();
      });
    });
  }

  // ── PULSANTE INDIETRO BREADCRUMB ───────────────────
  function initBackButton() {
    const backBtn = document.querySelector('.breadcrumbs_link .back-btn-icn');
    if (backBtn && window.history.length > 1) {
      backBtn.closest('.breadcrumbs_link').addEventListener('click', function (e) {
        e.preventDefault();
        window.history.back();
      });
    }
  }

  // ── CLICK SU TUTTA LA CARD PRODOTTO ───────────────
  function initCardClick() {
    document.querySelectorAll('product-card').forEach(function (card) {
      const link = card.querySelector('.product-column_heading a');
      const btn  = card.querySelector('.product-column_button-wrap');
      if (!link) return;
      card.style.cursor = 'pointer';
      card.addEventListener('click', function (e) {
        if (btn && btn.contains(e.target)) return;
        window.location.href = link.getAttribute('href');
      });
    });
  }

  // ── STICKY BAR - PULSANTE ATC ──────────────────────
  function initStickyATC() {
  function addStickyBtn() {
    const stickyBar = document.querySelector('sticky-block.main-product_sticky-bar');
    const stickyWrapper = stickyBar ? stickyBar.querySelector('.main-product_aside-card') : null;
    const mainForm = document.querySelector('#MainContent .main-product_submit-from');
    if (!stickyWrapper || !mainForm) return false;
    if (stickyWrapper.querySelector('.cranio-sticky-atc')) return true;

    const productId = mainForm.querySelector('[name="id"]')?.value;
    if (!productId) return false;

    const stickyBtn = document.createElement('div');
    stickyBtn.className = 'cranio-sticky-atc';
    stickyBtn.innerHTML = `
      <form method="post" action="/cart/add" class="js-contents--form" data-type="add-to-cart-form">
        <input type="hidden" name="id" value="${productId}">
        <input type="hidden" name="quantity" value="1">
        <button type="submit" class="button button--primary button--product-action">
          <span class="button--text">Aggiungi al carrello</span>
        </button>
      </form>
    `;
    if(window.currentVariantAvailable)
      stickyWrapper.appendChild(stickyBtn);

    // Sincronizza la variante selezionata
    const variantInput = mainForm.querySelector('[name="id"]');
    if (variantInput) {
      const variantObserver = new MutationObserver(() => {
        const stickyInput = stickyBtn.querySelector('[name="id"]');
        if (stickyInput) stickyInput.value = variantInput.value;
      });
      variantObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      variantInput.addEventListener('change', () => {
        const stickyInput = stickyBtn.querySelector('[name="id"]');
        if (stickyInput) stickyInput.value = variantInput.value;
      });
    }
    return true;
  }

  if (addStickyBtn()) return;

  const domObserver = new MutationObserver(() => {
    if (addStickyBtn()) {
      domObserver.disconnect();
    }
  });
  domObserver.observe(document.body, { childList: true, subtree: true });
}

  // ── INIT TUTTO ─────────────────────────────────────
  initProductPageButton();
  updateHeaderBubble();
  renderWishlistPage();
  initBackButton();
  initCardClick();
  initStickyATC();

});
